var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as debug from 'debug';
import { SocketService } from '@app/core/socket.service';
import { ReplyAbstractComponent } from '@app/shared/components/reply/reply-abstract.component';
import { DomSanitizer } from '@angular/platform-browser';
import { BalanceHistoryService } from '@app/core/account/balance-history.service';
// import { DiceService } from '@app/games/dice/services/dice.service';
var log = debug('edg:reply-dice');
var MersenneTwister = require('mersennetwister');
var ReplyDiceComponent = /** @class */ (function (_super) {
    __extends(ReplyDiceComponent, _super);
    function ReplyDiceComponent(socket, balanceHistory, sanitizer) {
        var _this = _super.call(this, socket, balanceHistory) || this;
        _this.socket = socket;
        _this.balanceHistory = balanceHistory;
        _this.sanitizer = sanitizer;
        _this.data = null;
        return _this;
    }
    ReplyDiceComponent.prototype.initialize = function (data) {
        if (['dice', 'spooky-dice', 'ice-dice'].indexOf(data.game) === -1) {
            this._error = true;
            return;
        }
        this.data = data.gameData;
        this.data.result = Number((this.data.result / 10).toFixed(1));
        log(this.data);
        this.sliderStyleBg = this.sanitizer.bypassSecurityTrustStyle('-webkit-gradient(linear, left top, right top, ' +
            'color-stop(' +
            this.data.slider / 100 +
            ', ' +
            (this.data.range ? '#3ecf8e' : '#ff6060') +
            '), ' +
            'color-stop(' +
            this.data.slider / 100 +
            ', ' +
            (!this.data.range ? '#3ecf8e' : '#ff6060') +
            ')' +
            ')');
        this._loading = false;
    };
    ReplyDiceComponent.prototype.generateGame = function () {
        var data = {
            gameData: {
                range: true,
                slider: 50,
                result: this.generateLuckyNr(this.serverSeed, this.playerSeed),
            },
            win: false,
            game: 'dice',
        };
        data.win = data.gameData.result / 10 <= 50;
        this.initialize(data);
    };
    ReplyDiceComponent.prototype.generateLuckyNr = function (serverSeed, clientSeed) {
        if (!serverSeed || !clientSeed) {
            return null;
        }
        clientSeed = clientSeed.replace('0x', '');
        serverSeed = serverSeed.replace('0x', '');
        var clSeedSplitted = clientSeed.match(/.{1,6}/g);
        var srvSeedSplitted = serverSeed.match(/.{1,6}/g);
        var seedsCombined = clSeedSplitted.concat(srvSeedSplitted);
        var seedsCominedNum = [];
        for (var i = 0; i < seedsCombined.length; i++) {
            seedsCominedNum[i] = parseInt(seedsCombined[i], 16);
        }
        var mt = new MersenneTwister();
        mt.seedArray(seedsCominedNum);
        return mt.int() % 1001;
    };
    return ReplyDiceComponent;
}(ReplyAbstractComponent));
export { ReplyDiceComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-dice.component.ts.pre-build-optimizer.js